import { apiClient, v2Client } from '@api/apiClient'
import { useAuthenticator } from '@features/auth/utils/useAuthenticator'
import { indexKeys } from '@features/indexing/hooks/indexKeys'
import { IndexStatusResponse } from '@features/indexing/hooks/types'
import { useQuery } from '@tanstack/react-query'

export const indexStatuses = {
  CREATED: 'CREATED',
  READY: 'READY',
  FAILED: 'FAILED',
  STOPPED: 'STOPPED',
  INITIALIZING: 'INITIALIZING',
  IN_PROGRESS: 'IN_PROGRESS',
  DELETED: 'DELETED',
} as const

export type IndexStatuses = (typeof indexStatuses)[keyof typeof indexStatuses]

export const useGetIndexStatus = () => {
  const { user } = useAuthenticator()
  return useQuery({
    enabled: !!user,
    queryKey: indexKeys.getIndexStatus,
    queryFn: () => v2Client.get<IndexStatusResponse>('/index'),
    select: (data) => data.data,
    refetchInterval: ({ state }) => {
      if (state?.data?.data?.status !== indexStatuses.READY) {
        return 5000
      }
      return false
    },
  })
}
